import intl from 'react-intl-universal';
import moment from 'moment';

// 这个方法原来是ES5的
function formatFlowList(list, options) {
  //interval默认是s为单位
  var sorttype = options.sorttype,
    _options__interval = options.interval,
    interval = _options__interval === undefined ? 30 * 60 : _options__interval,
    order = options.order,
    starttime = options.starttime,
    endtime = options.endtime;
  //默认可能会传null过来
  if (!sorttype) {
    sorttype = 'shoottime';
  }
  var before = {
    showName: intl.get('Not Started'),
    list: []
  }; //活动开始前的数据
  //更新： 活动结束后的时间直接用结束时间
  var after = {
    //showName: "活动结束后",
    showName: moment(endtime - 0).format('YYYY-MM-DD HH:mm'),
    list: []
  }; //活动开始后的数据
  var ing = []; //过程中
  list.forEach(function(one) {
    var time = one[sorttype] - 0;
    if (isNaN(time)) {
      // 没有给时间呢
    }
    if (time < starttime) {
      before.list.push(one);
    } else if (time <= endtime) {
      ing.push(one);
    } else {
      after.list.push(one);
    }
  });
  //const maxInterval = (endtime - starttime)/interval/1000;
  var formattedIng = [];
  ing.map(function(one) {
    var time = one[sorttype] - 0;
    var currentInterval = parseInt((time - starttime) / interval / 1000);
    if (!formattedIng[currentInterval]) {
      formattedIng[currentInterval] = {
        showName: moment(
          starttime - 0 + interval * 1000 * currentInterval
        ).format('YYYY-MM-DD HH:mm'),
        //showName : formatTime(getDate(starttime - 0 + interval * 1000 * currentInterval),true),
        list: []
      };
    }
    formattedIng[currentInterval].list.push(one);
  });
  //活动开始之前的时刻全部融合到活动开始的时间上来
  var beforeList = before.list;
  if (beforeList && beforeList.length) {
    //如果开始时间之后的interval时间之内是有数据的，直接用来合并，否则和一个空数组合并
    formattedIng[0] = formattedIng[0] || {
      showName: moment(starttime - 0).format('YYYY-MM-DD HH:mm'),
      list: []
    };
    formattedIng[0].list = beforeList.concat(formattedIng[0].list);
  }
  return order === 'desc'
    ? [after].concat(formattedIng.reverse()).filter(function(one) {
        return one;
      })
    : [].concat(formattedIng, [after]).filter(function(one) {
        return one;
      });
}
export default formatFlowList;
